import * as React from 'react';
import './ModalView.css';

// ------------------------------------------------------------------------------------------------
// component

interface Props {
    className?: string;
}

interface State {
}

class ModalView extends React.PureComponent<Props, State> {

    // --------------------------------------------------------------------------------------------
    // state

    public state = {
    };

    // --------------------------------------------------------------------------------------------
    // render

    public render() {
        let containerClass = "modal-view-container";
        if (this.props.className) {
            containerClass += " " + this.props.className;
        }
        return (
            <div className={containerClass}>
                <div className="modal-view-background" />
                <div className="modal-view-content">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default ModalView;
